import React from 'react'
import TabLinkUI from '../../../widgets/output/TabLinkUI'

const CustomerInvoicesNavUI = ({ context, account, page }) =>
  <div className='g_flex_h g_flex_left g_flex_wrap g_m_bottom_50'>
    <TabLinkUI label='Summary' to={`/su/accounts/${account.accountId}/rf`} active={page === 'rf'} />
    <TabLinkUI label='Monthly Interest Payments to Clime' to={`/su/accounts/${account.accountId}/rfTxns`} active={page === 'transactions'} />
    <TabLinkUI label='Monthly Limit' to={`/su/accounts/${account.accountId}/limit`} active={page === 'limit'} />
  </div>

export default CustomerInvoicesNavUI